import imgOne from '../../assets/blogs/1.png';
import imgTwo from '../../assets/blogs/2.png';
import imgThree from '../../assets/blogs/3.png';

const BlogData = [
    {
        img: imgOne,
        index: 1,
        url: 'is-root-canal-treatment-painful-india',
        title: 'Is Root Canal Treatment Painful? What Indian Patients Should Know',
        description: 'A clear, honest guide explaining whether root canal treatment is painful and how modern dentistry makes it comfortable.',
        category: 'ROOT CANAL'
    },
     {
        img: imgTwo,
        index: 2,
        url: 'bleeding-gums-causes-home-care-india',
        title: 'Bleeding Gums in India: Causes, Home Care & When to See a Dentist',
        description: 'Learn why bleeding gums are common in India, how to manage them at home, and when dental treatment is necessary.',
        category: 'GUM CARE'
    },
    
    {
        img: imgThree,
        index: 3,
        url: 'simple-dental-care-habits-for-healthy-smile',
        title: 'Simple Dental Care Habits for a Healthy Smile at Any Age',
        description: 'Easy daily dental care tips recommended by dentists to maintain healthy teeth and gums for all age groups.',
        category: 'ORAL HYGIENE'
    },
    {
        img: imgOne,
        index: 4,
        url: 'painless-dental-treatment-experience-patna',
        title: 'Painless Dental Treatment in Patna: What Patients Really Experience',
        description: 'Real patient experiences explaining why painless dental treatment matters and how modern dentistry makes it possible.',
        category: 'PATIENT EXPERIENCE'
    },
    {
        img: imgThree,
        index: 5,
        url: 'common-dental-problems-in-india-and-how-to-prevent-them',
        title: 'Common Dental Problems in India and How to Prevent Them',
        description: 'Learn about the most common dental problems faced by Indians and simple steps to prevent them effectively.',
        category: 'DENTAL HEALTH'
    },
    {
        img: imgTwo,
        index: 5,
        url: 'why-regular-dental-checkups-save-money-india',
        title: 'Why Regular Dental Checkups Save Money in the Long Run',
        description: 'Understand how routine dental visits help Indians avoid costly treatments and maintain long-term oral health.',
        category: 'AWARENESS'
    }
];

export default BlogData;